module.exports = __webpack_public_path__ + "img/public_7.1e551b53.jpg";